import React, { useContext } from "react";
import Turtle from "../../images/turtle.png";
import "./resume.css";
import resume from "../../images/Krishna_Khandelwal.pdf";
import { ModeContext } from "../utils/modes-context";

const Resume = () => {
  const { darkMode } = useContext(ModeContext);
  return (
    <section
      className={darkMode ? "resume" : "resume resume_lightmode"}
      id="resume">
      <div className="the_resume">
        <img src={Turtle} alt="tutle" />
        <h2>Grab my resume</h2>
        <p className="about">
          A front-end developer with expertise in JavaScript, React, HTML, and
          CSS. Passionate about learning new tech and creativity. Bringing the
          website to life and providing a seamless user experience to the
          audience. A part-time content creator.
        </p>
        <a href={resume} className="btn" download>
          Download
        </a>
      </div>
    </section>
  );
};

export default Resume;
